import React, { useContext } from 'react'
import MyContext from '../../context/data/myContext';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

function SearchBar4() {
    const context = useContext(MyContext)
    const { filteredData4, wordEntered4, handleFilter4, clearInput4 } = context
  return (
    <div>
        <div className="ml-auto flex items-center">
              <input type="text" placeholder='Buscar...' value={wordEntered4} onChange={handleFilter4} style={{outline: 'none'}} className='bg-gray-100'/>
                <div>
                    {filteredData4.length === 0 ? (<SearchIcon/>) : (<CloseIcon  id="clearBtn" onClick={clearInput4} />) }
                </div>
              </div>
      
    </div>
  )
}

export default SearchBar4